"use strict";

class ApplicationInstallerDialogCtrl {

    constructor($rootScope, $state, $scope, $mdDialog, $mdToast, $http, applicationId, widgets) {

        this.$mdDialog = $mdDialog;
        this.$mdToast = $mdToast;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$scope = $scope;
        this.$http = $http;
        this.widgets = widgets;

        this.applicationId = applicationId;

        this.$scope.cancel = () => {
            this.cancelButton();
        };

        this.$scope.ok = () => {
            this.ok();
        };

        this.$http.get('/marketplace/' + this.applicationId).then((response) => {
            this.$scope.application = response.data;
        });
    }

    cancelButton() {
        this.$mdDialog.cancel();
    }

    ok() {
        console.log(this.$scope.application.installer);
        this.$http.post('/applications/marketinstall', JSON.parse(this.$scope.application.installer))
            .then(() => {
                this.$mdToast.show({
                    templateUrl: '/partial/app.partials.toasts.installed?title=' + this.$scope.application.name,
                    hideDelay: 6000,
                    position: ('top right')
                });
                this.$mdDialog.hide();
                this.$rootScope.$broadcast('applicationsSaved');
                this.widgets.reloadWidgetsData();
                this.$state.go('stationsettings.applications.manage');
            });
    }
}

/*
 * Inject dependicies
 */
ApplicationInstallerDialogCtrl.$inject = ['$rootScope', '$state', '$scope', '$mdDialog', '$mdToast', '$http', 'applicationId', 'widgets'];

/*
 * Browsify connection: execute controller
 */
module.exports = ApplicationInstallerDialogCtrl;
